var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#444;}.cls-2{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.71,28.29h5.59s.39,0,.76-.15c0,0,.37-.15.65-.43l15-15s.28-.28.44-.65c0,0,.16-.37.16-.77,0,0,0-.4-.16-.77,0,0-.16-.37-.44-.65l-5.57-5.57s-.28-.28-.65-.44c0,0-.37-.16-.77-.16,0,0-.4,0-.77.16,0,0-.37.16-.65.44l-14.99,14.99s-.28.28-.43.65c0,0-.15.37-.15.76v5.58s0,.83.59,1.41c0,0,.59.59,1.41.59ZM26.29,11.3l-14.99,14.99h-5.59v-5.59l15-15h0s5.58,5.59,5.58,5.59h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23,16c.19.19.44.29.71.29s.52-.11.71-.29.29-.44.29-.71-.11-.52-.29-.71l-7-7c-.19-.19-.44-.29-.71-.29s-.52.11-.71.29c-.19.19-.29.44-.29.71s.11.52.29.71l7,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIEdit);
export default __webpack_public_path__ + "static/media/i_edit.19de1709319de3bb1719ff83fae54e3e.svg";
export { ForwardRef as ReactComponent };